// ============================================================
//  Cross-trade category registry.
//
//  Single source of truth for the trade → categories lookup used
//  by the estimate tool panel's Templates and Calculators tabs.
//  Add a new trade by creating its `<trade>.ts` file, importing
//  the array here, and registering one entry in CATEGORIES_BY_TRADE.
//
//  CategoryDef lives here (not in any individual trade file) so
//  every trade's category list shares the same shape contract.
// ============================================================

import type { LucideIcon } from 'lucide-react';
import { LANDSCAPING_CATEGORIES } from './landscaping';
import { ROOFING_CATEGORIES } from './roofing';
import { CONCRETE_CATEGORIES } from './concrete';
import { ELECTRICAL_CATEGORIES } from './electrical';
import { PLUMBING_CATEGORIES } from './plumbing';
import { HVAC_CATEGORIES } from './hvac';
import { PAINTING_CATEGORIES } from './painting';
import { CLEANING_CATEGORIES } from './cleaning';

export interface CategoryDef {
    id: string;
    label: string;
    icon: LucideIcon;
    note?: string;
}

/** Lookup table for trade → category list. Add entries here as new
 *  trades come online. The key matches `trades.ts` Trade.id. */
export const CATEGORIES_BY_TRADE: Record<string, CategoryDef[]> = {
    landscaping: LANDSCAPING_CATEGORIES,
    roofing: ROOFING_CATEGORIES,
    concrete: CONCRETE_CATEGORIES,
    electrical: ELECTRICAL_CATEGORIES,
    plumbing: PLUMBING_CATEGORIES,
    hvac: HVAC_CATEGORIES,
    painting: PAINTING_CATEGORIES,
    cleaning: CLEANING_CATEGORIES,
};
